function base64(code: string, type: string = ''): string {
    if (type) {
        return `data:${type};base64,${code}`;
    }

    return `data:;base64,${code}`;
}

// ----------------------------------------------------------------------------

export default base64;
